/**
 * Header - Application header component
 *
 * Provides consistent header across all pages with logo and navigation.
 * Contains brand identity and main navigation elements.
 */
import { Link, NavLink, useLocation } from 'react-router-dom';
import useHoverEffect from '../hooks/useHoverEffect';
import './Header.css';

const Header=()=>{
    const location=useLocation();
    const{onMouseEnter,onMouseLeave}=useHoverEffect('scale(1.05)','scale(1)');
    const navLinkClass=({isActive}:{isActive:boolean})=>`header-nav-link ${isActive?'header-nav-link-active':''}`;
    return(
        <header className="header">
            <div className="header-container">
                <Link to="/"className="header-logo"onMouseEnter={onMouseEnter}onMouseLeave={onMouseLeave}aria-label="QreditCharge API - Return to homepage">
                    <img src="/images/logo.png" alt="QreditCharge Logo" className="header-logo-img" />
                    QreditCharge
                </Link>
                <nav className="header-nav"role="navigation"aria-label="Main navigation">
                    <NavLink to="/docs"className={navLinkClass}aria-current={location.pathname==="/docs"?"page":undefined}aria-label="Navigate to documentation">
                        Documentation
                    </NavLink>
                    <NavLink to="/test"className={navLinkClass}aria-current={location.pathname==="/test"?"page":undefined}aria-label="Navigate to API testing interface">
                        API Testing
                    </NavLink>
                    <NavLink to="/admin"end className={navLinkClass}aria-current={location.pathname==="/admin"?"page":undefined}aria-label="Navigate to admin panel">
                        Admin
                    </NavLink>
                    <NavLink to="/analytics"className={navLinkClass}aria-current={location.pathname==="/analytics"?"page":undefined}aria-label="Navigate to analytics dashboard">
                        Analytics
                    </NavLink>
                </nav>
            </div>
        </header>
    );
};

export default Header;
